'use client'

import { useSelector } from "react-redux"

export default function privacy() {

    const CMS = useSelector((state) => state.CMS)

    return (
        <>
        <title>隱私權及資訊安全政策 - 放視大賞</title>
        <main id="main" className="privacy info-page">
            <div className="page-banner">
                <h1 className="page-banner-content">
                    <div className="sub-title text-[2.5rem]">隱私權及資訊安全政策</div>
                </h1>
            </div>
            <div className="info-content">
                <div className="prose max-w-none text">
                    放視大賞（以下簡稱本執行單位）尊重並保護您在使用網際網路時的安全及隱私，為了幫助您瞭解「放視大賞網站（以下簡稱本網站）」如何保護您在使用本網站各項服務的安全、及如何蒐集、應用及保護您所提供的個人資訊，請您詳細閱讀「放視大賞網站」的隱私保護及安全政策。
                    <h2 className="title mt-10 mb-4">一、網路安全保護措施</h2>
                    任何未經授權而企圖上載或更改本網站所提供的各項服務及相關資訊的行為，都是嚴厲禁止而且可能觸犯法律。為了網站安全的目的和確保這項服務能夠繼續服務所有的網路使用者，本網站提供了以下的安全保護措施：
                    <ol className="m-0">
                        <li>使用網路入侵偵測系統，監控網路流量，以確認未經授權而企圖上載或更改、網頁資訊或蓄意破壞者。</li>
                        <li>裝設防火牆防止非法入侵、竊取或破壞資料，以避免網站遭到非法使用，以保障使用者的權益。</li>
                        <li>裝設掃毒軟體，定期掃毒，以提供使用者更安全的網頁瀏覽環境。</li>
                    </ol>
                    <h2 className="title mt-10 mb-4">二、隱私權政策宣示適用範圍</h2>
                    以下的隱私權政策，適用於您在本網站活動時，所涉及的個人資料蒐集、運用與保護，但不適用於與經由本網站功能連結之其他網站。凡經由本網站連結之網站，各網站均有其專屬之隱私權政策，本網站不負任何連帶責任。當您連結這些網站時，關於個人資料的保護，適用各該網站的隱私權政策。
                    <h2 className="title mt-10 mb-4">三、個人資料收集方式</h2>
                    本網站透過以下幾種管道收集您的個人資料：
                    <ol className="m-0">
                        <li>線上報名活動：當您申請參加本網站線上報名活動時，需提供個人資料，本網站依辦理需求請您提供姓名、身分證字號、電話、電子信箱及住址等個人資訊。您若因為本網站的廣告活動宣導之超連結，而參與其他網站或機構主辦的報名、抽獎、競賽或行銷活動，對於您主動提供的個人資訊，這些機構或連結網站各有其個別的隱私權保護政策，其資料處理措施不適用本網站隱私權保護政策，本網站無法負擔任何連帶責任。</li>
                        <li>一般瀏覽：單純在本網站瀏覽及檔案下載行為，本網站不會蒐集任何有關個人的身份資料。</li>
                    </ol>
                    <h2 className="title mt-10 mb-4">四、個人資料之運用方式</h2>
                    <ol className="m-0">
                        <li>
                            本網站有義務保護您的隱私，非經您本人同意不會自行修改或刪除任何個人資料及檔案。除非經過您事先同意或符合以下情況始得為之：
                            <ol className="m-0" type="a">
                                <li>經由合法的途徑。</li>
                                <li>違反本網站規定事項，如於公開網頁中出現謾罵或做人身攻擊的言論時。</li>
                                <li>保護或防衛相關網路民眾的權利或所有權。</li>
                                <li>為保護本網站各相關單位之權益。</li>
                            </ol>
                        </li>
                        <li>
                            本網站絕不會任意出售、交換、或出租任何您的個人資料給其他團體、個人或私人企業。但有下列情形者除外：
                            <ol className="m-0" type="a">
                                <li>配合司法單位合法的調查。</li>
                                <li>配合相關職權機關依職務需要之調查或使用。</li>
                                <li>基於善意相信揭露為法律需要，或為維護和改進網站服務而用於管理。</li>
                                <li>本網站所收集的姓名、身分證字號、電話、e-mail 及住址等資訊，僅供活動報名、領獎、履歷媒合活動及分析之用，並不做其他用途。其他資料僅止於服務分析或學術用途。除非您同意，否則所有資料僅供資料分析之用，本網站不會將該等資料用做其他用途。</li>
                            </ol>
                        </li>
                    </ol>
                    <h2 className="title mt-10 mb-4">五、個人應盡之義務</h2>
                    <ol className="m-0">
                        <li>凡登記成為本網站會員並利用本網站提供之線上服務者，皆有義務維持並更新其所屬個人資料，並確保該資料為正確、最新以及完整性。</li>
                        <li>若您提供任何錯誤或不實的資料，本網站各相關經營單位有權拒絕您以該帳號使用網站之全部或部份服務。</li>
                        <li>維持密碼及帳號的機密安全，是本網站及各相關經營單位與您共同的責任。</li>
                        <li>您的密碼或帳號遭到盜用或有其他任何安全問題發生時，請您立即以電子郵件通知本網站，以便資訊人員協助處理。</li>
                        <li>確保每次連線完畢，均會登出帳號使用以保護個人帳號不會遭到其他人濫用。若您是與他人共享電腦或使用公共電腦，切記要關閉瀏覽器視窗，以防止他人讀取您的個人資料或信件。</li>
                        <li>所有網路民眾行為應遵循國內、外法律規範，並且對於個人所屬帳號、密碼所發生之情事負全部責任。</li>
                    </ol>
                    <h2 className="title mt-10 mb-4">六、隱私權暨資訊安全保護政策修訂</h2>
                    本網站會不定時修訂本項政策，以符合最新之隱私權保護規範。當本網站在使用個人資料的規定做較大幅度修改時，本網站會在網頁上張貼告示，通知您相關事項。
                    <h2 className="title mt-10 mb-4">七、隱私權暨資訊安全保護政策諮詢</h2>
                    如果您對於本網站的隱私權保護政策或是有個人資料收集、運用、更新等問題，請於上班時間聯絡：{CMS.registries['cms.home.footer.phone']}，或來信至服務信箱 {CMS.registries['cms.home.footer.email']}。
                </div>   
            </div>
        </main>
        </>
    )
}